import React from 'react'
import { Grid } from '@mui/material'
import { headerCells } from './data'
import NoDataMessage from "../../deprecatedUikit/NoDataMessage/NoDataMessage";
import InfoCard, { IData } from "../../deprecatedUikit/InfoCard/InfoCard";
import {styles} from "../styles";

interface SupplierAccountsReceivableContentProps {
  loading: boolean;
  invoices: Array<{ id: string; [key: string]: unknown }>;
  handleToggle: (id: string) => void;
  /** O(1) lookup for whether a given invoice id is currently expanded. */
  isExpanded: (id: string) => boolean;
}

const SupplierAccountsReceivableContent = ({
  loading,
  invoices,
  handleToggle,
  isExpanded,
}: SupplierAccountsReceivableContentProps) => {
  return (
    <Grid container flexDirection='column' mb={4} mt={4} sx={{
      ...(!invoices.length && !loading) && styles.container,
      '& .css-13i4rnv-MuiGrid-root': {
        wordWrap: 'normal',
      },
      '@media(max-width: 39.28em)': {
        '& .css-13i4rnv-MuiGrid-root': {
          top: '4%',
        }
      }

    }}>
      {(!invoices.length && !loading) ? (
        <Grid sx={styles.showMessage}>
          <NoDataMessage
            image="/app-images/person-and-box.svg"
            message="No matching records found."
          />
        </Grid>
      ) : (
        invoices.map((invoice) => (
          <InfoCard
            headCells={headerCells}
            data={invoice as IData}
            hasAction={false}
            key={invoice.id}
            handleToggle={handleToggle}
            collapse={isExpanded(invoice.id)}
          />
        ))
      )}
    </Grid>
  )
}

export default SupplierAccountsReceivableContent
